import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Container, Row, Col } from 'reactstrap';
import QRCode from 'qrcode.react'
import {withRouter} from 'react-router-dom'
import {getQRCode,closeQRCode} from '../../actions/rollActions'
import isEmpty from '../../validation/is-empty';
var interval;
class RollCall extends Component {
  componentDidMount(){
    this.props.getQRCode(this.props.match.params.id)
    interval = setInterval(()=>{
      this.props.getQRCode(this.props.match.params.id)
    },10000)
  }
  componentWillUnmount(){
    clearInterval(interval)
    this.props.closeQRCode(this.props.match.params.id)
  }
  render() {
    const {current,loading} = this.props.rollcalls
    let content;
    if(!loading){
      if(!isEmpty(current)){
        content = <QRCode value={current.CurrentQR} renderAs="canvas" includeMargin={true} level="H" size={400}/>
      }
    }
    console.log(current)
    return (
      <Container fluid style={{height:'100vh'}} >
        <Row className="align-items-center h-100 justify-content-center">
          <Col className="text-center" xs="6">
            {content}
          </Col>
        </Row>
      </Container>
    )
  }
}

RollCall.propTypes = {
  auth: PropTypes.object.isRequired,
  rollcalls:PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth,
  rollcalls:state.rollcalls,
  errors: state.errors
});

export default connect(mapStateToProps,{getQRCode,closeQRCode})(withRouter(RollCall));


// WEBPACK FOOTER //
// ./src/components/pages/viewRollCall.js